<template>
  <Dialog :visible="visible" class="irinox-dialog-light" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '500px'}" :draggable="false"
              @update:visible="updateVisible" @show="show">
    
    <template #header>
      <img src="assets/irinox/icons/arrow_back.svg" @click="updateVisible(false)" :alt="$t('common.arrow_left')"/>
      <div>{{$t('userinfo.updatePassword.title')}}</div>
    </template>

    <div class="irinox-dialog-light-content layout-content">
      <div class="irinox-form p-pt-2">
        <div class="p-fluid p-formgrid p-grid p-pl-4 p-pr-4">
              <div class="p-field p-col">
                  <label for="old">{{$t('userinfo.updatePassword.old')}}</label>
                  <Password inputId="old" v-model="password.old" 
                    :placeholder="$t('userinfo.updatePassword.old_ph')"
                    :class="{'p-invalid':!password.old && submitted}" toggleMask  :feedback="false"
                    />
              </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-pl-4 p-pr-4">
              <div class="p-field p-col">
                  <label for="new">
                    {{$t('userinfo.updatePassword.new')}}
                    <i class="pi pi-info-circle" v-tooltip="$t('signup.password_tooltip')"/>
                  </label>
                  <Password inputId="new" v-model="password.new" 
                    :placeholder="$t('userinfo.updatePassword.new_ph')"
                    :class="{'p-invalid':isPasswordInvalid}" toggleMask  :feedback="false"
                    />
                  <div v-if="isPasswordInvalid" class="form-field-error">{{$t('signup.password_tooltip')}}</div>
                  
              </div>
        </div>
        <div class="p-fluid p-formgrid p-grid p-pl-4 p-pr-4">
              <div class="p-field p-col">
                  <label for="repeat">{{$t('userinfo.updatePassword.repeat')}}</label>
                  <Password inputId="repeat" v-model="password.repeat" 
                    :placeholder="$t('userinfo.updatePassword.repeat_ph')"
                    :class="{'p-invalid':isRepeatPasswordInvalid}" toggleMask :feedback="false"
                    />
              </div>
        </div>
      </div>
    </div>

    <template #footer>
      <Button :label="$t('userinfo.updatePassword.update_button')" @click="buttonClick"/>
    </template>
  </Dialog>
</template>

<script>
export default {
    emits: ['update:visible','click:button'],
    props: {
      visible: Boolean,
    },
    data() {
        return {
          submitted: false,
          password: {
            old: null,
            new: null,
            repeat: null
          }
        };
    },
    computed: {
      isPasswordInvalid: function() {
          return (!this.password.new || !this.$functions.passwordCheck(this.password.new) || this.password.new.length<10) && this.submitted
        },
      isRepeatPasswordInvalid: function() {
          return (!this.password.repeat || this.password.repeat!=this.password.new) && this.submitted;
        }
    },
    methods: {
      updateVisible(value) {
        if(!value) {
          this.submitted = false;
          this.password = {
            old: null,
            new: null,
            repeat: null
          };
        }
        this.$emit("update:visible", value);
      },
      buttonClick() {
        this.submitted = true;

        if(!this.password.old || !this.password.new || !this.password.repeat || this.password.new!=this.password.repeat) {
          return;
        }
        this.$emit("click:button", this.password);

      },
      show() {
        this.submitted = false;
        this.password = {
            old: null,
            new: null,
            repeat: null
          };
      },
    }
}
</script>

<style scoped>

.form-field-error {
  color: #A70008;
  margin-top: 5px;
  font-size: 15px;
  line-height: 17px;
  text-align: left;
}

</style>